import {
  ICredentials,
  ICreateUserCredentials,
  // IAuthorizationResult,
  IDoctorsData,
  IRegistrationResult,
  IResponse,
  IIndastriesData,
  IProvidersData,
  IUserSearchData,
  IProfession,
  IData,
  IProfessionDetail,
  IVerifyCode,
  // IToken,
} from '@/types/interfaces';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '@/store/mainStore';
import LocalStorageService from '@/services/LocalStorageService';
// eslint-disable-next-line import/no-cycle
import WebsocketService from '@/services/WebsocketService';
// eslint-disable-next-line import/no-cycle
import ApiService from '@/services/ApiService';
// eslint-disable-next-line import/no-cycle
import UserService from '@/services/UserService';

export default class RegistrationService {
  public static register(credentials: ICredentials): Promise<IResponse<IRegistrationResult>> {
    return ApiService.postAndReturnData('registration/register', credentials).then((response) => {
      if (response.success) {
        LocalStorageService.setAuthToken(response.results.authToken);
        return UserService.fetchAndStoreUser().then(() => response);
      }
      LocalStorageService.removeAuthToken();
      LocalStorageService.removeGmtId();
      return response;
    });
  }

  public static cancelRegistration(): Promise<IResponse<null>> {
    const mainStore = useMainStore();
    return ApiService.deleteAndReturnData('/registration/cancel').then((response) => {
      if (response.success) {
        mainStore.resetAllStores();
        LocalStorageService.removeAuthToken();
        WebsocketService.closeSocket();
      }
      return response;
    });
  }

  public static setAccountInfo(accountInfo: ICreateUserCredentials): Promise<IResponse<any>> {
    return ApiService.postAndReturnData('/registration/fill-account-info', accountInfo);
  }

  public static getDoctorsData(payload: IUserSearchData): Promise<IResponse<IDoctorsData>> {
    const searchString = payload.npi
      ? `npi=${payload.npi}&firstName=${payload.firstName}&lastName=${payload.lastName}`
      : `firstName=${payload.firstName}&lastName=${payload.lastName}`;
    return ApiService.getAndReturnData(`/registration/npi/doctors?${searchString}`);
  }

  public static getIndastriesData(): Promise<IResponse<IIndastriesData>> {
    return ApiService.getAndReturnData('/registration/industries');
  }

  public static getProvidersData(): Promise<IResponse<IProvidersData>> {
    return ApiService.getAndReturnData('/registration/providers');
  }

  public static getHealthcareData(): Promise<IResponse<IData<IProfession[]>>> {
    return ApiService.getAndReturnData('/common/healthcare');
  }

  public static getProfessionDetailData(value: number): Promise<IResponse<IData<IProfessionDetail>>> {
    return ApiService.getAndReturnData(`/common/profession/${value}`);
  }

  public static sendVerifyCode(phoneNumber: string): Promise<IResponse<any>> {
    return ApiService.getAndReturnData(`/registration/verify-code/send/${phoneNumber}`);
  }

  public static checkVerifyCode(payload: IVerifyCode): Promise<IResponse<IData<string>>> {
    return ApiService.postAndReturnData('/registration/verify-code/check/', payload);
  }
}
